import "./styles.less";

import { usePropertyModalTour3d } from "./PropertyModalTour3d.hook";

export const TourIframe: React.FC<{ url: string; iframeId?: string }> = ({
	url,
	iframeId = "",
}) => (
	<iframe
		width="100%"
		height="100%"
		src={url}
		id={iframeId}
		frameBorder="0"
		allowFullScreen
		allow="xr-spatial-tracking"></iframe>
);

export const PropertyModalTour3d = ({ tour3dUrl }) => {
	// const { url } = usePropertyModalTour3d({ id });
	return (
		<div className="property-modal-tour3d">
			<TourIframe url={tour3dUrl} iframeId="tour3d" />
		</div>
	);
};
